import { Effect, Option } from 'effect';

import { getAuthTokenOption } from '@vs-shop/engine/utils/cookies/getAuthToken';

export const hasAuthToken = Effect.gen(function* () {
  const token = yield* getAuthTokenOption;

  return Option.match(token, {
    onNone: () => false,
    onSome: () => true,
  });
});
